import classNames from 'classnames'
import { memo } from 'react'
import { twMerge } from 'tailwind-merge'
import bean from '../assets/beans-cartoon.png'
import coin from '../assets/coin.png'
import giftIcon from '../assets/gift.png'
import star from '../assets/star.png'

interface Props {
  coins?: boolean
  points?: boolean
  beans?: boolean
  banner?: boolean
  gift?: boolean
  imgItem?: string
  className?: string
}

export const Reward = memo(
  ({ coins, points, beans, banner, gift, imgItem, className }: Props) => {
    return (
      <>
        {coins && (
          <img
            src={coin}
            className={classNames(twMerge('w-4 h-4', className))}
          />
        )}

        {points && (
          <img
            src={star}
            className={classNames(twMerge('w-4 h-4', className))}
          />
        )}

        {beans && (
          <img
            src={bean}
            className={classNames(twMerge('w-4 h-4', className))}
          />
        )}

        {gift && (
          <img
            src={giftIcon}
            className={classNames(twMerge('w-4 h-4', className))}
          />
        )}

        {banner && (
          <img
            src={giftIcon}
            className={classNames(twMerge('w-4 h-4', className))}
          />
        )}

        {imgItem && (
          <img
            src={imgItem}
            className={classNames(twMerge('w-4 h-4', className))}
          />
        )}
      </>
    )
  },
)

Reward.displayName = 'Reward'
